<style lang="scss" scoped src="./style/index.scss"></style>
<style lang="scss" src="./style/stepDialog.scss"></style>
<style lang="scss">
.page-unfreeze {
  .stepDialog {
    .addImpowerDialogFooter {
      display: inline-block;
      padding-left: 180px;
      width: 100%;
      @media screen and (max-device-width: 400px) {
        padding-left: 0;
      }

      .el-button {
        margin-left: 0;
        @media screen and (max-device-width: 400px) {
          width: 100%;
        }
      }
    }

    .step-item {
      padding-right: 80px;
      @media screen and (max-device-width: 400px) {
        padding-right: 0;
      }
    }

    .el-form-item.is-error {
      margin-bottom: 24px;
    }
  }
}

</style>
<template>
    <div class="page-unfreeze app-page">
        <step-dialog
            ref="stepDialog"
            model="inner"
            :step.sync="stepIndex"
            :options="stepOpt"
            :finish="finish"
            :next="next"
            v-if="stepDialogShow">
            <div slot="step-1">
                <div class="step-item">
                    <mobile-login
                        @keyup-next="onKeyup"
                        ref="captchaForm"
                        :formData="captchaForm"
                        :formDataRule="captchaFormRule"></mobile-login>
                </div>
            </div>
            <div slot="step-2">
                <div class="step-item">
                    <new-pwd
                        @keyup-submit="onSubmit"
                        ref="newPwd"
                        :model="editPwdForm"
                        :current-user-info="currentUserInfo"></new-pwd>
                </div>
            </div>
        </step-dialog>
    </div>
</template>
<script>
import { mapState } from 'vuex';
import store from './store';
import newPwd from './newPwd.vue';
import mobileLogin from './login.vue';

/**
 * 密码重置 账号解冻 手机号修改共用组件
 */
export default {
  name: 'appCloudUnfreeze',

  components: {
    newPwd,
    mobileLogin,
  },

  beforeRouteEnter(to, from, next) {
    if (isNaN(to.params.step)) {
      next('/');
      return;
    }
    if (to.path === '/pwd/reset/2' || to.path === '/pwd/unfreeze/2') {
      next((vm) => {
        this.$api[to.query.auth === 'email' ? 'emailAuth' : 'mobileAuth'].currentUser().then(() => {
          let msg = 'unfreeze';
          if (vm.isResetPage) msg = 'pwdReset';
          vm.$store.dispatch('appCloudHeaderStore/changeTitle', msg);
        });
      });
    } else {
      next((vm) => {
        let msg = 'unfreeze';
        if (vm.isResetPage) msg = 'pwdReset';
        vm.$store.dispatch('appCloudHeaderStore/changeTitle', msg);
      });
    }
  },

  beforeCreate() {
    if (!this.$store.state.appCloudUnfreezeStore) {
      this.$store.registerModule('appCloudUnfreezeStore', store);
    }
  },

  data() {
    const currentPageType = this.$route.params.type;

    return {
      currentPageType,
      acountSureForm: {
        account: '',
        captcha: '',
      },
      captchaForm: {
        areaCode: 86,
        mobile: '',
        smscode: '',
        email: '',
        emailcode: '',
      },
      editPwdForm: {
        account: '',
        oldPwd: '',
        newPwd: '',
        pwdSure: '',
      },
      currentInfor: {
        encryptionCode: null,
        mobile: '',
      },
      currentUserInfo: {
        userName: '',
        employeeNo: '',
        domainAccount: '',
        mobile: '',
      },
      stepDialogShow: true,
    };
  },
  watch: {
    currentPageStep(val) {
      this.stepIndex = val;
    },
  },
  computed: {
    ...mapState({
      pageHeight: state => state.appCloudLayoutStore.bodyMinHeight,
      rule: state => state.appCloudLayoutStore.rules,
    }),

    stepIndex: {
      get() {
        const step = Number(this.$route.params.step);
        if (step === 2) this.getCurrentUserInfo();
        return step;
      },
      set(val) {
        if (val === 2) this.getCurrentUserInfo();
        this.stepDialogShow = false;
        this.$nextTick(() => {
          this.stepDialogShow = true;
        });
      },
    },

    pageStyle() {
      return {
        height: `${this.pageHeight}px`,
      };
    },

    currentPageStep() {
      return Number(this.$route.params.step);
    },

    stepOpt() {
      const currentPageType = this.isResetPage ? 'pwdReset' : 'unfreeze';

      return [{
        title: this.$t('i18n.authentication'),
        btn: this.$t('i18n.nextStep'),
        'prev-btn-hide': true,
      }, {
        title: this.$t(`i18n.${currentPageType}`),
        btn: this.$t('i18n.finish'),
        'prev-btn-hide': true,
      }];
    },

    acountSureFormRule() {
      const { rule } = this;
      return {
        account: rule.adminAccount(1, 255, this.$t('i18n.accountErrorMsg')),
      };
    },

    captchaFormRule() {
      const { rule } = this;
      let mobileRule = rule.mobile(1, 11, this.$t('i18n.phonePlaceholder'), this.$t('i18n.invalidFormat'));
      if (this.captchaForm.areaCode !== 86) {
        mobileRule = [
          { required: true, message: this.$t('i18n.phonePlaceholder'), trigger: 'blur' },
          { min: 1, message: this.$t('i18n.invalidFormat'), trigger: 'blur' },
        ];
      }
      return {
        mobile: mobileRule,
        smscode: rule.captcha(1, 32, this.$t('i18n.cptPhonePlaceholder')),
        email: rule.email(1, 255, this.$t('i18n.emailPlaceholder'), this.$t('i18n.invalidFormat')),
        emailcode: rule.captcha(1, 32, this.$t('i18n.cptEmailPlaceholder')),
      };
    },

    editPwdFormRule() {
      const { rule } = this;
      const validPwd = (rules, value, callback) => {
        if (value !== this.editPwdForm.newPwd) {
          callback(new Error(this.$t('i18n.pwdInconformity')));
        } else {
          callback();
        }
      };
      return {
        newPwd: rule.password(1, 32, this.$t('i18n.newPwdErrorMsg')),
        pwdSure: [
          { required: true, message: this.$t('i18n.surePwdErrorMsg'), trigger: 'blur' },
          { validator: validPwd, trigger: 'blur' },
        ],
      };
    },

    /**
         * 是否启用邮箱验证
         * @returns {boolean} 是否
         */
    isEmailAuth() {
      return this.$route.query.auth === 'email';
    },

    /**
         * 是否是重置页面
         * @returns {boolean} 是否
         */
    isResetPage() {
      return this.$route.params.type === 'reset';
    },

    /**
         * 是否是密码重置或帐号解冻页面
         * @returns {boolean} 是否
         */
    isResetOrUnfreezePage() {
      return /reset|unfreeze/.test(this.$route.params.type);
    },
  },
  methods: {
    finish(data, resolves, done) {
      resolves(new Promise((resolve) => {
        this.$refs.newPwd.getValidResault((valid) => {
          if (!valid) {
            setTimeout(() => {
              done();
            });
            // return false;
          } else {
            this.$store.dispatch('appCloudLayoutStore/getPublicKey').then((result) => {
              if (result.code !== 'success') {
                return;
              }

              this.$api[this.isEmailAuth ? 'emailAuth' : 'mobileAuth'][this.isResetPage ? 'resetPassword' : 'unlockAccount']({
                password: this.editPwdForm.pwdSure,
              }).then((res) => {
                this.$router.push('/statePage/success');
                resolve(res);
                return false;
              }).catch(() => {
                done();
              });
            });
          }
        });
      }));
    },

    next(value, next, step, resolves) {
      if (step !== 1) {
        return;
      }
      const loginRef = this.$refs.captchaForm;
      loginRef.$refs.formData.validate((valid) => {
        if (!valid) {
          return;
        }
        const promise = new Promise((resolve, reject) => {
          this.$store.dispatch('appCloudLayoutStore/getPublicKey').then((result) => {
            if ((result).code !== 'success') {
              return;
            }
            const params = {
              ...this.captchaForm,
            };
            // 如果是账号解冻或密码重置组件增加stype作为操作行为区分
            if (this.isResetOrUnfreezePage) {
              params.stype = 1;
              if (!this.isResetPage) {
                params.stype = 2;
              }
            }
            this.$api[this.isEmailAuth ? 'emailAuth' : 'mobileAuth'].login(params).then(() => {
              this.$router.push(`/pwd/${this.isResetPage ? 'reset' : 'unfreeze'}/2${this.isEmailAuth ? '?auth=email' : ''}`);
              this.getCurrentUserInfo();
            }).catch((err) => {
              resolve(err);
            });
          }).catch(reject);
        });

        resolves(promise);
      });
    },

    getCurrentUserInfo() {
      this.$api[this.isEmailAuth ? 'emailAuth' : 'mobileAuth'].currentUser().then((res) => {
        if (res.code === 'success') {
          this.currentUserInfo = Object.assign(this.currentUserInfo, res.data);
        }
      });
    },

    getPhone(resolve) {
      this.$api.getMobile(this.currentInfor.encryptionCode).then((res) => {
        resolve(res);
        if (res.code === 'success') {
          if (res.data) {
            this.captchaForm.mobile = res.data;
          }
        }
      });
    },

    getUrlParam(para, str) {
      let index;
      let paraArr;
      if (str) {
        index = str.indexOf('?');
        paraArr = str.slice(index + 1).split('&');
      } else {
        index = window.location.href.indexOf('?');
        paraArr = window.location.href.slice(index + 1).split('&');
      }
      for (let i = 0; i < paraArr.length; i++) {
        if (para === paraArr[i].split('=')[0]) {
          return paraArr[i].split('=')[1];
        }
      }
      return '';
    },

    onKeyup() {
      this.$refs.stepDialog.nextStep();
    },

    onSubmit() {
      this.$refs.stepDialog.stepfinish();
    },
  },
};

</script>
